// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1145":"47792cb5f2b80787","3066":"1421909aa27982bf","4266":"4fcbf88bd1346f0c","5076":"c612fbea8ed1dddd"}[chunkId] + ".css";
};